import React, { useRef } from "react";

import { ES, US, DE, GB, PL, FR } from 'country-flag-icons/react/3x2'
import { OverlayPanel } from 'primereact/overlaypanel';
import { LANGUAGES } from "../../constants/common";

type Props = {
    currentLang: string;
    onSetLanguage: (lang: string) => void;
};

const LanguageFlag: React.FC<Props> = (props: Props) => {

    const { currentLang, onSetLanguage } = props;
    const flagRef = useRef<any | null>(null);

    const setLanguage = (lang: string) => {
        onSetLanguage(lang)
    }

    const toggleFlag = (event: any) => {
        flagRef.current.toggle(event);
    };

    const showFlag = (lang: string) => {

        switch (lang) {
            case 'en':
                return <><US title="English" className="flag-size" /></>;
            case 'gb':
                return <> <GB title="English" className="flag-size" /></>;
            case 'pl':
                return <> <PL title="Spanish" className="flag-size" /></>;
            case 'es':
                return <> <ES title="Spanish" className="flag-size" /></>;
            case 'fr':
                return <>  <FR title="Spanish" className="flag-size" /></>;
            case 'de':
                return <><DE title="German" className="flag-size" /></>;
            default:
                return '';
        }
    };

    const showButtonFlag = (flag: any) => {
        return <button onClick={() => {
            setLanguage(flag.name);
            flagRef.current.hide();
        }} className="p-link" tabIndex={0} style={{ cursor: "pointer" }} >
            {showFlag(flag.name)}
        </button>
    };

    return (
        <>
            <button onClick={toggleFlag} className="p-link" tabIndex={0} style={{ cursor: "pointer" }} >
                {showFlag(currentLang)}
            </button>
            <OverlayPanel ref={flagRef} appendTo={document.body} showCloseIcon id="overlay_panel" style={{ width: '50px' }}>
                {LANGUAGES.map(flag => (
                    <span key={'fl_' + flag.id} >
                        {showButtonFlag(flag)}
                    </span>
                ))}

            </OverlayPanel>
        </>
    )
}

export default LanguageFlag;